export const getToastMessage = (state) => state.general.toastMessage;
